import {
  SESSION_CHECK_START,
  SESSION_CHECK_SUCCESS,
  SESSION_CHECK_FAILURE,
  SESSION_CLEAR,
  SESSION_SET,
  SESSION_RESET_CHECK,
} from "./sessionTypes";
import { checkSessionWithLoading } from "../../helper/checkSession";

// Action Creators
export const sessionCheckStart = () => ({
  type: SESSION_CHECK_START,
});

export const sessionCheckSuccess = (sessionData) => ({
  type: SESSION_CHECK_SUCCESS,
  payload: sessionData,
});

export const sessionCheckFailure = (error) => ({
  type: SESSION_CHECK_FAILURE,
  payload: error,
});

export const sessionClear = () => ({
  type: SESSION_CLEAR,
});

export const sessionSet = (token, userData) => ({
  type: SESSION_SET,
  payload: { token, userData },
});

export const sessionResetCheck = () => ({
  type: SESSION_RESET_CHECK,
});

// Thunk Actions
export const performSessionCheck = (timeoutMs = 5000) => async (dispatch, getState) => {
  const { session } = getState();
  if (session.isChecking) return { isValid: false };

  dispatch(sessionCheckStart());
  try {
    // Use the new function with timeout and loading indicator
    const result = await checkSessionWithLoading(timeoutMs);
    dispatch(sessionCheckSuccess(result));
    return result;
  } catch (error) {
    const errorResult = { 
      isValid: false, 
      message: error.message === 'Session check timeout' ? 'Session check timeout' : 'Session check failed', 
      data: null 
    };
    dispatch(sessionCheckFailure(errorResult));
    return errorResult;
  }
};

export const clearSessionData = () => (dispatch) => {
  dispatch(sessionClear());
};

export const setSessionData = () => (dispatch) => {
  dispatch(sessionSet());
};

export const resetSessionCheckStatus = () => (dispatch) => {
  dispatch(sessionResetCheck());
};
